export function useStatus (prop, t$) {
  const statusIcons = {
    active: '$symbols-circle-check-filled',
    activating: '$symbols-circle-plus-filled',
    deactivated: '$brand-locaweb-filled',
    deleting: '$brand-locaweb-filled'
  }
  const statusColor = {
    active: 'success',
    activating: 'gray',
    deactivated: 'gray',
    deleting: 'gray'
  }

  const status = {
    active: 'active',
    activating: 'activating',
    deactivated: 'deactivated',
    deleting: 'deleting'
  }

  return {
    value: t$[prop],
    icon: statusIcons[prop],
    color: statusColor[prop],
    status: status[prop]
  }
}
